export function getFullUrlPage(path = "") {
  // Получаем протокол (http или https)
  const protocol = window.location.protocol;

  // Получаем хост (домен и порт)
  const host = window.location.host;

  // Формируем полный URL
  const fullUrl = `${protocol}//${host}${path}`;

  return fullUrl;
}
